<template>
  <div class="common-block">
    <div class="common-title-wrap">
      <span>{{ blockName }}</span>
    </div>
    
    <div class="common-news-wrap">
      <commonNewsCell v-for="(item,ind) in newsList" :key="ind" :newsItem="item"/>
    </div>
  </div>
</template>

<script>
import commonNewsCell from '../../../components/common-news-cell'
import { getNewsList, getEduList } from '../../../service/api' 

export default {
  components: {
    commonNewsCell
  },
  name: 'app',
  props:{
    rmsId: Number,
    pageSize: Number,
    blockName: String,
    type: String
  },
  data(){
    return{
      newsList: []
    }
  },
  mounted() {
    // 获取新闻列表
     if(this.type==='kt'){
      getEduList({
        page_size: 10,
        page_num: 1
      }).then(res => {
        let _arr = []
        if(res.data.data.data_list && res.data.data.data_list.length){
          for(let i=0;i<4;i++) {
            _arr.push(res.data.data.data_list[i])
          }
        }
        this.newsList = _arr
      })
    } else {
      getNewsList({
        api_type: this.rmsId,
        page_size: this.pageSize,
        page_num: 1
      }).then(res => {
        this.newsList = res.data.data.data_list
      })
    }
    
  },
  methods:{
    
  }
}
</script>

<style lang="less">
@import '../../../common/global.less';
.common-block{
  .common-title-wrap{
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 15px;
    span{
      color:#fff;
      font-size:18px;
      font-weight: bold;
      padding:10px 28px;
      background-color:#376ED2;
    }
    &:after{
      content: '';
      height:2px;
      flex:1;
      background-color: #C4D2EA;
    }
  }
  .common-news-wrap{
    .common-news-cell{
      &:last-child{
        border-bottom: none;
      }
    }
  }
}
</style>

